<template>
  <card-item>
    <template>
      <div class="d-flex justify-content-center align-items-center">
        <h4 class="card-title">Modificar cliente</h4>
      </div>
    </template>
    <template v-if="!isLoading">
      <form
        v-promise-btn="{ action: 'submit' }"
        @submit.prevent="submit"
        class="container"
      >
        <div class="row">
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="nombre">Nombre</label>
            <input
              id="nombre"
              v-model="nombre"
              :class="`form-control form-control-sm text-center bg-white${
                !isNombreOk && isDirty ? ' is-invalid' : ''
              }`"
              style="cursor: text"
              type="text"
            />
          </div>
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="apellido">Apellido</label>
            <input
              id="apellido"
              v-model="apellido"
              :class="`form-control form-control-sm text-center bg-white${
                !isApellidoOk && isDirty ? ' is-invalid' : ''
              }`"
              style="cursor: text"
              type="text"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="nombreWeb">Nombre Web</label>
            <input
              id="nombreWeb"
              v-model="nombreWeb"
              :class="`form-control form-control-sm text-center bg-white${
                !isNombreWebOk && isDirty ? ' is-invalid' : ''
              }`"
              style="cursor: text"
              type="text"
            />
            <small class="form-text text-muted"
              >Con este nombre aparecerá en el sistema.</small
            >
          </div>
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="telCelular">Teléfono celular</label>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span id="prefijo" class="input-group-text">+54</span>
              </div>
              <input
                id="telCelular"
                v-model="telCelular"
                :class="`form-control form-control-sm text-center bg-white${
                  !isTelCelularOk && isDirty ? ' is-invalid' : ''
                }`"
                aria-describedby="prefijo"
                style="cursor: text"
                type="text"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="emailFacturacion"
              >Email facturación</label
            >
            <input
              id="emailFacturacion"
              v-model="emailFacturacion"
              class="form-control form-control-sm text-center bg-white"
              style="cursor: text"
              type="text"
            />
          </div>
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="emailGerencia">Email Gerencia</label>
            <input
              id="emailGerencia"
              v-model="emailGerencia"
              :class="`form-control form-control-sm text-center bg-white${
                !isEmailGerenciaOk && isDirty ? ' is-invalid' : ''
              }`"
              style="cursor: text"
              type="text"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="usuario">Usuario</label>
            <input
              id="usuario"
              v-model="usuario"
              :class="`form-control form-control-sm text-center bg-white${
                !isUsuarioOk && isDirty ? ' is-invalid' : ''
              }`"
              style="cursor: text"
              type="text"
            />
          </div>
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="password">Contraseña</label>
            <div class="input-group">
              <input
                :type="showPassword ? 'text' : 'password'"
                id="password"
                :class="`form-control form-control-sm text-center bg-white${
                  !isPasswordOk && isDirty ? ' is-invalid' : ''
                }`"
                v-model="password"
              />
              <div class="input-group-addon">
                <a @click="changeShowPassword">
                  <i
                    :class="`fa fa-eye${!showPassword ? '' : '-slash'}`"
                    aria-hidden="true"
                  ></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <ModificarCobranzasForm />

        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between">
              <button
                class="btn btn-secondary"
                type="button"
                @click="cancelarModal"
              >
                Cancelar
              </button>
              <button class="btn btn-primary" type="submit">Aceptar</button>
            </div>
          </div>
        </div>
      </form>
    </template>
    <div v-else>Cargando...</div>
  </card-item>
</template>

<script>
import ModificarCobranzasForm from "./ModificarCliente/ModificarCobranzasForm.vue";
import Bindings from "../../pages/Clientes/ModificarCliente/Bindings";
import { get } from "lodash-es";
import axios from "axios";

export default {
  name: "ModificarCliente",
  mixins: [Bindings],
  components: {
    ModificarCobranzasForm,
  },
  mounted() {
    this.idCliente = this.$router.currentRoute.params.id_cliente;
    this.getData().then((data) => {
      this.isLoading = true;
      if (get(data, "ok", true) === false) {
        this.$msgBoxOk(data.message);
      }
      this.isLoading = false;
    });
  },
  data: () => ({
    showPassword: false,
    isDirty: false,
    idCliente: null,
    isLoading: true,
  }),
  methods: {
    changeShowPassword() {
      this.showPassword = !this.showPassword;
    },
    async submit() {
      this.isDirty = true;

      const idUbicacionDinero = get(
        this.idCobranzaLugarDePago,
        "id_ubicacion_dinero",
      );
      if (!idUbicacionDinero) {
        this.$msgBoxOk("Por favor, elija un lugar de cobranza .");
        return;
      }

      if ([29, 48].includes(idUbicacionDinero)) {
        if (!this.isTarjetaOk) {
          this.$msgBoxOk("Por favor, complete el campo número de tarjeta .");
          return;
        }
      } else if (idUbicacionDinero === 33) {
        if (!this.isCodigoRapipagoOk) {
          this.$msgBoxOk("Por favor, complete el campo código rapipago");
          return;
        }
      }

      if (this.isDataOk) {
        const resp = await this.$store.dispatch(
          "clientes/ModificarCliente/submit",
          { idCliente: this.idCliente },
        );
        if (resp.ok) {
          this.$router.push("/admin/clientes/");
        } else {
          this.$msgBoxOk(resp.message);
        }
      }
    },
    cancelarModal() {
      this.$router.push("/admin/clientes");
    },
    async getData() {
      const resp = await axios.post("/execute", {
        method: "CLI.GetClienteConCobranzaByClienteId",
        parameters: [
          {
            name: "id_cliente",
            value: this.$route.params.id_cliente,
          },
        ],
      });

      if (get(resp, "data.ok", false)) {
        this.$store.commit(
          "clientes/ModificarCliente/inicializarCliente",
          get(resp, "data.result[0][0]", null),
        );
      }

      this.isDirty = false;
      return resp.data;
    },
  },
  computed: {
    isDataOk() {
      return (
        this.isNombreOk &&
        this.isApellidoOk &&
        this.isNombreWebOk &&
        this.isEmailGerenciaOk &&
        this.isUsuarioOk &&
        this.isPasswordOk
      );
    },
    isNombreOk() {
      return this.nombre !== "";
    },
    isApellidoOk() {
      return this.apellido !== "";
    },
    isNombreWebOk() {
      return this.nombreWeb !== "";
    },
    isTelCelularOk() {
      return this.telCelular !== "";
    },
    isEmailGerenciaOk() {
      return this.emailGerencia !== "";
    },
    isUsuarioOk() {
      return this.usuario !== "";
    },
    isPasswordOk() {
      return this.password !== "";
    },
    isTarjetaOk() {
      return this.numeroTarjeta && this.numeroTarjeta.trim() !== "";
    },
    isCodigoRapipagoOk() {
      return this.codigoRapipago && this.codigoRapipago.trim() !== "";
    },

    empresaPropia: {
      get() {
        return this.$store.state.clientes.ModificarCliente.empresaPropia;
      },
    },
    codigoRapipago: {
      get() {
        return this.$store.state.clientes.ModificarCliente.codigoRapipago;
      },
    },
    numeroTarjeta: {
      get() {
        return this.$store.state.clientes.ModificarCliente.nroTarjeta;
      },
    },
    idCobranzaLugarDePago: {
      get() {
        return this.$store.state.clientes.ModificarCliente
          .idCobranzaLugarDePago;
      },
      set(val) {
        this.$store.commit(
          "clientes/ModificarCliente/setIdCobranzaLugarDePago",
          val,
        );
      },
    },
  },
};
</script>

<style scoped></style>
